import React from "react";
import { UTILS } from "utils";

import { useTranslation } from "react-i18next";

function Support({ orderNo, phone, heading, heading2 }) {
  const { t } = useTranslation();
  const displayOrderNo =
    orderNo !== undefined && orderNo !== null && orderNo !== ""
      ? orderNo
      : "-";

  const rowClass =
    "flex flex-wrap justify-between gap-x-8 gap-y-2 py-3 text-gray-900";

  return (
    <div className="mt-2 w-full">
      {phone ? (
        <div className={rowClass}>
          <span className="font-semibold shrink-0">{heading2}</span>
          <button
            type="button"
            className="text-left text-gray-900 hover:text-primary focus:outline-none focus:underline cursor-pointer"
            onClick={() => {
              navigator.clipboard.writeText(phone);
              UTILS.successNotification(t("Copied to Clipboard"));
            }}
          >
            <span dir="ltr">{phone}</span>
          </button>
        </div>
      ) : null}
      <div className={rowClass}>
        <span className="font-semibold shrink-0">{heading}</span>
        <button
          type="button"
          className={`text-left focus:outline-none ${
            displayOrderNo === "-"
              ? "text-gray-900 cursor-default"
              : "text-gray-900 hover:text-primary focus:underline cursor-pointer"
          }`}
          onClick={() => {
            if (displayOrderNo === "-") return;
            navigator.clipboard.writeText(String(orderNo));
            UTILS.successNotification(t("Copied to Clipboard"));
          }}
        >
          {displayOrderNo}
        </button>
      </div>
    </div>
  );
}

export default Support;
